function Footer() {
	return (
		<footer>
			<p>
				Inventory images credits to Unsplash. Icon credits to
				FontAwesome and SVGRepo.
			</p>
			<p>
				Made by <a href="https://ish.codes/">Ishween Sehmbhi</a>{" "}
				at <a href="https://junocollege.com/">Juno College</a>,
				2022.
			</p>
		</footer>
	);
}

export default Footer;
